define('NSeComm.CustomProductCollection.Main', [
    'CustomProductCollection.PDP.Styles.View',
    'CustomProductCollection.PLP.Styles.View',
    'CustomProductCollection.MainAction.View',
    'CustomProductCollection.FacetHelper',
    'jQuery',
    'underscore'
], function NSeCommCustomProductCollectionMain(
    CustomProductCollectionPDPStylesView,
    CustomProductCollectionPLPStylesView,
    CustomProductCollectionMainActionView,
    FacetHelper,
    jQuery,
    _
) {
    'use strict';

    /**
     * Entrypoint module for the Custom Product Collection SuiteCommerce extension.
     * Attaches custom PDP/PLP/Cart/Search/Environment logic and UI extensions.
     * All components (PDP, PLP, Cart, Search, Environment) must be registered in the container.
     */
    return {
        /**
         * Mounts the extension to the SuiteCommerce app container.
         * Configures custom PDP and PLP child views, facet filters, UI suppression, and event bindings.
         * @param {ApplicationContainer} container - SuiteCommerce app extension container
         */
        mountToApp: function mountToApp(container) {
            // Core SuiteCommerce components required for this extension:
            var pdpComponent = container.getComponent('PDP');
            var plpComponent = container.getComponent('PLP');
            var cartComponent = container.getComponent('Cart');
            var searchComponent = container.getComponent('Search');
            var environmentComponent = container.getComponent('Environment');
            var productDetailsFields;

            if (
                !pdpComponent ||
                !plpComponent ||
                !cartComponent ||
                !searchComponent ||
                !environmentComponent
            ) {
                return;
            }

            productDetailsFields = environmentComponent.getConfig(
                'customProductCollection.productDetailsFields'
            );

            FacetHelper.setupMasterFacet(environmentComponent);

            pdpComponent.addChildView('Product.Options', function addProductDetailsChildView() {
                return new CustomProductCollectionMainActionView({
                    searchComponent: searchComponent,
                    cartComponent: cartComponent,
                    pdpComponent: pdpComponent,
                    productDetailsFields: productDetailsFields
                });
            });

            pdpComponent.addChildView('Product.Options', function addProductDetailsChildView() {
                /**
                 * This style module hides elements not relevant to custom product collection PDP pages:
                 * @hidden add to cart, add to wishlist, quantity box, price, description, add to quote
                 */
                return new CustomProductCollectionPDPStylesView();
            });

            plpComponent.addChildView('StockDescription', function addProductListChildView() {
                /**
                 * This style module hides elements not relevant to custom product collection PLP pages:
                 * @hidden price, quick view
                 */
                return new CustomProductCollectionPLPStylesView();
            });

            pdpComponent.on('afterShowContent', function afterShowContent() {
                var itemInfo = pdpComponent.getItemInfo();

                // parent item
                if (itemInfo && itemInfo.item && itemInfo.item.custitem_cpc_is_parent_item) {
                    // clear prices from metadata because it is wrong
                    // matrix items have no price in these meta elements
                    _(function delayedFunction() {
                        jQuery('meta[property="twitter:data1"]').attr('content', '');
                        jQuery('meta[property="og:price:standard_amount"]').attr('content', '');
                    }).delay();
                }
            });
        }
    };
});
